import { SVGProps } from 'react';

export const DataTableToolbarUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="49"
    height="28"
    viewBox="0 0 49 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.5059 10.2436L20.7431 11.4809L23.6245 8.59949V17.8622H25.3745V8.59949L28.2559 11.4809L29.4931 10.2436L24.4995 5.24999L19.5059 10.2436Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.75 19.25V21H19.25V19.25H17.5V21C17.5 21.9651 18.2849 22.75 19.25 22.75H29.75C30.7151 22.75 31.5 21.9651 31.5 21V19.25H29.75Z"
      fill="currentColor"
    />
  </svg>
);
